module.exports = __webpack_public_path__ + "img/shape-1.56d2603b.png";